
























    import { Vue,Component, Watch } from 'vue-property-decorator'
    import { State,Action,namespace, Getter } from 'vuex-class'
    import * as moment from 'moment'
    const financial = namespace('financial')
    @Component
    export default class Home extends Vue{
        list:any[] = [] //列表数据
        @financial.State('loading') loading:any 
        @State('dictionaries') dictionaries:any
        @Getter('comArea') comArea:any
        search:any = {
            com_area: '',
            month: moment().format('YYYY-MM'),
        } 
        get height(){
			return (document.body.offsetHeight - 244)+'px';
		}
        get tablecolumn(){
            return [
                {
                    prop: 'siteName',
                    type: 'text',
                    label: '网点名称',
                },
                {
                    prop: 'pkNum',
                    type: 'text',
                    label: '派件数量',
                },{
                    prop: 'pkPerProfit',
                    type: 'text',
                    label: '派件均价',
                }
                ,{
                    prop: 'exNum',
                    type: 'text',
                    label: '寄件数量',
                }
                ,{
                    prop: 'pkProfit',
                    type: 'text',
                    label: '派件收入',
                },{
                    prop: 'exProfit',
                    type: 'text',
                    label: '寄件利润',
                },{
                    prop: 'exPerProfit',
                    type: 'text',
                    label: '寄件平均利润',
                },{
                    prop: 'exMoney',
                    type: 'text',
                    label: '寄件收入',
                },{
                    prop: 'exCost',
                    type: 'text',
                    label: '寄件成本',
                },{
                    prop: 'pkCash',
                    type: 'text',
                    label: '派件流水',
                },{
                    prop: 'exCash',
                    type: 'text',
                    label: '寄件流水',
                },{
                    prop: 'addCash',
                    type: 'text',
                    label: '增值流水',
                },{
                    prop: 'otherCash',
                    type: 'text',
                    label: '其他流水',
                },{
                    prop: 'pkRecharge',
                    type: 'text',
                    label: '派件充值总额',
                    width: '110px',
                },{
                    prop: 'pkReAmount',
                    type: 'text',
                    label: '派件充值',
                },{
                    prop: 'pkRePresent',
                    type: 'text',
                    label: '派件充值赠送',
                    width: '110px'
                }
            ]
        }
        @financial.Action('getAnalyzeList') getAnalyzeList:any
        @financial.Action('putAnalyzeList') putAnalyzeList:any
        created(){
            this.getList()
            this.search.com_area = this.comArea[0].code
        }
        async getList(){
            const res = await this.getAnalyzeList(this.search)
            this.list = res;
            // if(res){
            //     // this.list = res.docs
            //     const list = res.map((item:any,key:string) => {
            //         for(let val in item){
            //             if(val != '_id'){
            //                 if(val == 'site'){
            //                     item[val] = {
            //                         value: item[val].name,
            //                         dblStatus: false,
            //                         disbal: true
            //                     }
            //                 }else{
            //                     item[val] = {
            //                         value: item[val],
            //                         dblStatus: false,
            //                         disbal: false
            //                     }
            //                 }
            //             }
                        
            //         }
            //         return item
            //     })
            //     console.log(list);
            //     this.list = list
            // }
        }
        // 编辑表格提交
        async editCel({key, val,id}:any){
            console.log({key:val})
            await this.putAnalyzeList({
                id: id,
                data: {
                    [key]:val
                }
            })
        }
        // 导出数据
        exportexcel(){
            const data = this.list;
            if(data.length < 1) return this.$message.error('选择需要导出的数据')
            require.ensure([], () => {
                const { export_json_to_excel } = require('../../assets/vendor/Export2Excel');
                const tHeader = ['网点名称','派件数量','寄件数量', '派件收入','派件均价','寄件均利润','寄件利润','寄件收入','寄件成本','派件流水','寄件流水','增值流水','其他流水','派件充值总额','派件充值','派件充值赠送'];
                const p = [tHeader]
                data.map((item:any)=>{
                    p.push([
                        item.siteName,
                        item.pkNum,
                        item.exNum,
                        item.pkProfit,
                        item.pkPerProfit,
                        item.exPerProfit,
                        item.exProfit,
                        item.exMoney,
                        item.exCost,
                        item.pkCash,
                        item.exCash,
                        item.addCash,
                        item.otherCash,
                        item.pkRecharge,
                        item.pkReAmount,
                        item.pkRePresent,
                    ])
                })
                const pk = [{
                    sheetName:"经营月报",
                    data:p
                }];
                const extitle = `${this.search.month}.${this.search.com_area}.经营月报`
                export_json_to_excel(pk,extitle);
            })
        }
    }
